import React from "react";
import logo from "./logo.svg";
import "./App.css";

function App() {
    return (
        <div className="App">
            <header className="App-header">
                <img src={logo} className="App-logo" alt="logo" />
                <a className="App-link" href="/use-state">
                    Fun Learning React Hooks
                </a>
            </header>
        </div>
    );
}

export default App;
